import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

import "../../css_pages/table.css";
import "../../css_pages/form.css";
import "../../css_pages/services.css";
import "../../css_pages/type_travo.css";
import "../../css_pages/ajoute_travaux.css";
import "../../css_pages/variables.css";

export default function AdminLayout({ title, searchValue, onSearchChange, placeholder, children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Track screen size
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setSidebarOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Close sidebar when clicking outside on mobile
  useEffect(() => {
    if (!sidebarOpen) return;
    const handleClick = (e) => {
      if (!e.target.closest(".admin-sidebar") && !e.target.closest(".hamburger-btn")) {
        setSidebarOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [sidebarOpen]);

  // Prevent body scroll when mobile sidebar is open
  useEffect(() => {
    document.body.style.overflow = sidebarOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [sidebarOpen]);

  return (
    <div style={{ display: "flex", minHeight: "100vh", position: "relative" }}>

      {/* Dark overlay — mobile only */}
      {isMobile && sidebarOpen && (
        <div
          onClick={() => setSidebarOpen(false)}
          style={{
            position: "fixed", inset: 0,
            background: "rgba(0,0,0,0.5)",
            zIndex: 99,
            backdropFilter: "blur(2px)",
            transition: "opacity 0.2s",
          }}
        />
      )}

      {/* Sidebar */}
      <Sidebar
        open={sidebarOpen}
        isMobile={isMobile}
        onClose={() => setSidebarOpen(false)}
      />

      {/* Main area */}
      <div style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        minWidth: 0,
      }}>
        <Topbar
          title={title}
          searchValue={searchValue}
          onSearchChange={onSearchChange}
          placeholder={placeholder}
          isMobile={isMobile}
          onMenuClick={() => setSidebarOpen(prev => !prev)}
        />
        <div style={{
          padding: isMobile ? "12px" : "20px",
          flex: 1,
          overflowX: "hidden",
        }}>
          {children}
        </div>
      </div>

    </div>
  );
}